import {Nullable, PageInfoType, QuestionEdgeType} from "../../definitions/types";
import {QuestionEdgeModel} from "../domain/questionEdgeModel";
import {PageInfoModel} from "../domain/pageInfoModel";

export class QuestionsModel {
    private readonly _questionEdges: QuestionEdgeModel[];
    private readonly _pageInfo: PageInfoModel;

    constructor(connectionType: { edges: Nullable<QuestionEdgeType>[]; pageInfo: PageInfoType }) {
        this._questionEdges = connectionType.edges
            .filter((questionEdge): questionEdge is QuestionEdgeType => questionEdge !== null)
            .map(questionEdge => new QuestionEdgeModel(questionEdge));
        this._pageInfo = new PageInfoModel(connectionType.pageInfo);
    }

    /**
     * @method questionEdges
     * @description Gets the questions items for the model instance.
     * @returns {QuestionEdgeModel[]}
     */
    public get questionEdges(): QuestionEdgeModel[] {
        return this._questionEdges;
    }

    /**
     * @method questionEdgeCount
     * @description Gets the count of questions items for the model instance.
     * @returns {number}
     */
    public get questionEdgeCount(): number {
        return this._questionEdges.length;
    }

    /**
     * @method hasQuestionEdges
     * @description Returns true if the model instance has questions items.
     * @returns {boolean}
     */
    public get hasQuestionEdges(): boolean {
        return this.questionEdgeCount > 0;
    }

    /**
     * @method pageInfo
     * @description Gets the page info for the model instance.
     * @returns {PageInfoModel}
     */
    public get pageInfo(): PageInfoModel {
        return this._pageInfo;
    }
}